import { useMemo } from 'react';
import {
  EnhancedSection,
  FormSchemaConfig,
} from '../../types/form/schema.types';
import { FormState } from '../../types';

export const useReassignmentSchema = (
  formState: FormState
): FormSchemaConfig => {
  return useMemo<FormSchemaConfig>(() => {
    const reassignmentSection: EnhancedSection = {
      title: { text: 'Reassign Request', type: 'h3' },
      layout: 'single',
      fields: [
        {
          type: 'text',
          name: 'currentAuthStage',
          label: 'Current Authorisation Stage',
          required: true,
          disabled: true,
        },
        {
          type: 'text',
          name: 'currentlyAssignedTo',
          label: 'Currently assigned to',
        },
        {
          type: 'radio',
          name: 'reassignRequest',
          label: 'Do you want to reassign this request?',
          options: [
            {
              value: 'yesReassignRequest',
              label: 'Yes',
              disabled: false,
            },
            {
              value: 'noReassignRequest',
              label: 'No',
              disabled: false,
            },
          ],
          validation: [
            {
              type: 'required',
              message: 'Please select an option',
            },
          ],
          errorMessages: {
            required: 'Please select whether you want to reassign this request',
          },
        },
      ],
      extras: { grouped: true, evenSpacing: true },
    };
    return {
      sections: [reassignmentSection],
    };
  }, [formState]);
};
